import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSolverViewportsSizeM from './IconSolverViewports_size_m';

const props: CreateIconArguments = {
  l: IconSolverViewportsSizeM,
  m: IconSolverViewportsSizeM,
  s: IconSolverViewportsSizeM,
  xs: IconSolverViewportsSizeM,
  name: 'IconSolverViewports',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
